/**
 * Enumeration to list all possible states for a subcontract request
 */
export enum SubcontractRequestState {
  NEW = 'new',
  WAITING = 'waiting',
  ACCEPTED = 'accepted',
  REFUSED = 'refused',
  CANCELED = 'canceled',
}
